import {createAction} from '@reduxjs/toolkit'

import {Variant} from './interfaces'

export type AddVariantProps = {
    experimentId: string
    variant: Variant
}

/** AB test 데이터 추가 */
export const addVariant = createAction<AddVariantProps>('abTest/addVariant')

export const addNaverId = createAction<string>('abTest/addNaverId')

export const setTrafficId = createAction<string>('abTest/setTrafficId')
